'use strict';

import React      from 'react';
import PropTypes  from 'prop-types';
import classNames from 'classnames';

import LoginSection        from './login-section';
import PhotoStorageMessage from './photo-storage-message';

const notLoggedIn = props => (
  <div className="h-100">
    <LoginSection />
    <div className={classNames({'modal-overlay': props.showAlert})}>
      <PhotoStorageMessage
        isOpen={props.showAlert}
        onClose={props.handleCloseAlert}
        storeName={props.storeName + '.com'}
      />
      <div className={classNames('psp-trigger justify-content-center d-md-none', props.showAlert ? 'd-none' : 'd-flex')}>
        <p>Read&nbsp;
          <a
            aria-label={`Read ${props.storeName} Photo Storage Policy`}
            className="sign-up"
            href="#"
            role="link"
            onClick={(e) => props.toggleShowAlert(e)}
          >
            {`${props.storeName} Photo Storage Policy`}
          </a>
        </p>
      </div>
    </div>
  </div>
);

notLoggedIn.propTypes = {
  showAlert: PropTypes.bool.isRequired,
  handleCloseAlert: PropTypes.func,
  storeName: PropTypes.string,
  toggleShowAlert: PropTypes.func,
};

export default notLoggedIn;
